import TemplateView from '../../../../TemplateView'
import {ReportType} from '../../../constants'
import StaffPerformanceDescriptionStrategy from './StaffPerformanceDescriptionStrategy'
import OvertimeDescriptionStrategy from './OvertimeDescriptionStrategy'
import LeaveTimeDescriptionStrategy from './LeaveTimeDescriptionStrategy'
import TimeTrackDetailDescriptionStrategy from './TimeTrackDetailDescriptionStrategy'
import EstimateVsActualDescriptionStrategy from './EstimateVsActualDescriptionStrategy'
import BillingSummaryDescriptionStrategy from './BillingSummaryDescriptionStrategy'
import InvoiceDescriptionStrategy from './InvoiceDescriptionStrategy'
import CostOfWorkDescriptionStrategy from './CostOfWorkDescriptionStrategy'
import ProfitLossDescriptionStrategy from './ProfitLossDescriptionStrategy'
import CustomFieldsDescriptionStrategy from './CustomFieldsDescriptionStrategy'
import messageResource from '../../../../messageResource'
import WorkStatusesDescriptionStrategy from './WorkStatusesDescriptionStrategy'
import TimeCardsDescriptionStrategy from './TimeCardsDescriptionStrategy'


export default class ReportDescriptionSection extends TemplateView {
    constructor({
        reportUrls = {},
        reportNameKeys = {},
    }) {
        super()

        this.params = {
            reportUrls,
            reportNameKeys,
        }

        this.state = {
            selectedType: null,

            userInDar: false,
            overtimeAvailable: false,
            enabledFeatures: {},
            userRights: {},
            hasSick: false,
            hasPTO: false,
        }

        this.onAnyStatePropertyChanged(['selectedType'], (state) => {
            const generator = this.generators[state.selectedType]

            generator.setState(state)

            this.$header.text(generator.getHeader())
            this.$description.html(generator.getDescription())
            this.$detailsLink.off().click(() => generator.getDetailsCallback())
            this.$configureButton.off().click(() => generator.getGenerateCallback())
        })
    }

    templateHtml() {
        return '<div class="sectionContent">' +
               '  <div class="header"></div>' +
               '  <div class="description"></div>' +
               '  <div class="details">' +
               '   <span class="link"><%-details%></span><span>>></span>' +
               '  </div>' +
               '  <div class="configureButton components_button"><%-configureButton%></div>' +
               '</div>'
    }

    templateModel() {
        return {
            details: messageResource.getMessage('dashboard.description.see_details'),
            configureButton: messageResource.getMessage('dashboard.description.configure_button'),
        }
    }

    afterRender() {
        this.$header = this.find('.header')
        this.$description = this.find('.description')
        this.$detailsLink = this.find('.details .link')
        this.$configureButton = this.find('.configureButton')


        this.generators = {
            [ReportType.STAFF_PERFORMANCE]: new StaffPerformanceDescriptionStrategy({
                name: this.params.reportNameKeys[ReportType.STAFF_PERFORMANCE],
                reportUrl: this.params.reportUrls[ReportType.STAFF_PERFORMANCE],
            }),
            [ReportType.OVERTIME]: new OvertimeDescriptionStrategy({
                name: this.params.reportNameKeys[ReportType.OVERTIME],
                reportUrl: this.params.reportUrls[ReportType.OVERTIME],
            }),
            [ReportType.LEAVE_TIME]: new LeaveTimeDescriptionStrategy({
                name: this.params.reportNameKeys[ReportType.LEAVE_TIME],
                reportUrl: this.params.reportUrls[ReportType.LEAVE_TIME],
            }),
            [ReportType.TIME_TRACK_IN_DETAIL]: new TimeTrackDetailDescriptionStrategy({
                name: this.params.reportNameKeys[ReportType.TIME_TRACK_IN_DETAIL],
                reportUrl: this.params.reportUrls[ReportType.TIME_TRACK_IN_DETAIL],
            }),
            [ReportType.ESTIMATED_VS_ACTUAL]: new EstimateVsActualDescriptionStrategy({
                name: this.params.reportNameKeys[ReportType.ESTIMATED_VS_ACTUAL],
                reportUrl: this.params.reportUrls[ReportType.ESTIMATED_VS_ACTUAL],
            }),

            [ReportType.BILLING_SUMMARY]: new BillingSummaryDescriptionStrategy({
                name: this.params.reportNameKeys[ReportType.BILLING_SUMMARY],
                reportUrl: this.params.reportUrls[ReportType.BILLING_SUMMARY],
            }),
            [ReportType.INVOICING]: new InvoiceDescriptionStrategy({
                name: this.params.reportNameKeys[ReportType.INVOICING],
                reportUrl: this.params.reportUrls[ReportType.INVOICING],
            }),
            [ReportType.COST_OF_WORK]: new CostOfWorkDescriptionStrategy({
                name: this.params.reportNameKeys[ReportType.COST_OF_WORK],
                reportUrl: this.params.reportUrls[ReportType.COST_OF_WORK],
            }),
            [ReportType.PROFIT_LOSS]: new ProfitLossDescriptionStrategy({
                name: this.params.reportNameKeys[ReportType.PROFIT_LOSS],
                reportUrl: this.params.reportUrls[ReportType.PROFIT_LOSS],
            }),
            [ReportType.CUSTOM_FIELDS]: new CustomFieldsDescriptionStrategy({
                reportUrl: this.params.reportUrls[ReportType.CUSTOM_FIELDS],
            }),
            [ReportType.WORK_STATUSES]: new WorkStatusesDescriptionStrategy({
                reportUrl: this.params.reportUrls[ReportType.WORK_STATUSES],
            }),
            [ReportType.TIME_CARDS]: new TimeCardsDescriptionStrategy({
                reportUrl: this.params.reportUrls[ReportType.TIME_CARDS],
            }),
        }
    }
}


// WEBPACK FOOTER //
// ./web/js/reports/dashboard/createReportPopup/components/ReportDescriptionSection.js